import React from "react";

const Landing = () => {
  return (
    <section className="landing text-center">
      <div className="container grad-img">
        <h2>Diploma Alumni</h2>
        <div className="image">
          <img src="img/Graduation Photo.png" alt="..." />
        </div>
      </div>
    </section>
  );
};

export default Landing;
